import { useEffect } from 'react'
import { Navigate, Routes } from 'react-router-dom'
import { useAuth } from './core/Auth'
import { useLogout } from './core/_requests'
import { queryCache } from '../../../queries/client'

export function Logout() {
  const { logout } = useAuth()
  const logoutMutation = useLogout()

  useEffect(() => {
    logoutMutation.mutate(
      {},
      {
        onSuccess: () => {
          queryCache.clear()
          logout()
          window.location.href = '/auth'
        },
        onError: (error) => {
          console.error('Failed to logout:', error)
        },
      }
    )
    document.location.reload()
  }, [])

  return (
    <Routes>
      <Navigate to='/auth' />
    </Routes>
  )
}
